import React, { useEffect, useState } from "react";
import "./TestimonialSnippet.css";

const API_URL =
  "https://featurable.com/api/v1/widgets/82ebafb5-8f43-409c-8cfd-510b68b25707"; // Featurable API URL
const MAX_LENGTH = 180; // Max number of characters before truncation

const TestimonialSnippet = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedReviews, setExpandedReviews] = useState({});

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const response = await fetch(API_URL);
        const data = await response.json();

        if (data.success && data.reviews) {
          setReviews(data.reviews.slice(0, 3)); // Display only the first 3 reviews
        } else {
          throw new Error("No reviews found");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  const toggleReadMore = (reviewId) => {
    setExpandedReviews((prev) => ({
      ...prev,
      [reviewId]: !prev[reviewId],
    }));
  };

  if (loading) {
    return <p>Loading testimonials...</p>;
  }

  if (error) {
    return <p className="error-message">Error: {error}</p>;
  }

  const formatReviewerName = (fullName) => {
    const nameParts = fullName.split(" ");
    if (nameParts.length > 1) {
      return `${nameParts[0]} ${nameParts[1][0]}.`;
    }
    return nameParts[0];
  };

  return (
    <div className="testHomeContainer">
      <h1>What Our Customers Think</h1>
      <div className="snippetContainer">
        {reviews.length === 0 ? (
          <p>No reviews available.</p>
        ) : (
          reviews.map((review) => {
            const isExpanded = expandedReviews[review.reviewId];
            const shouldTruncate = review.comment.length > MAX_LENGTH;
            const reviewText =
              isExpanded || !shouldTruncate
                ? review.comment
                : `${review.comment.slice(0, MAX_LENGTH)}...`;

            return (
              <div key={review.reviewId} className="testimonialSnip">
                <p>
                  "{reviewText}"
                  {shouldTruncate && (
                    <button
                      onClick={() => toggleReadMore(review.reviewId)}
                      className="readMoreBtn"
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </button>
                  )}
                </p>
                <p className="testimonialName">{formatReviewerName(review.reviewer.displayName)}</p>
              </div>
            );
          })
        )}
      </div>
      <button className="testimonialButton">
        <a href="/testimonials"  rel="noopener noreferrer">
          Testimonials
        </a>
      </button>
    </div>
  );
};

export default TestimonialSnippet;
